export default "__VITE_ASSET__C0Ed7_i8__"